import { IconProps } from 'types/icon.type'

export const EyeOffIcon = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Eye Off icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.74286 7.29565C2.13198 7.15366 2.56252 7.35399 2.70452 7.7431C3.3748 9.57996 4.57365 11.1754 6.14769 12.3299C6.16094 12.339 6.17398 12.3485 6.1868 12.3585C6.23347 12.3924 6.28047 12.4259 6.32779 12.459C7.99053 13.6222 9.97071 14.2461 12 14.2461C14.0292 14.2461 16.0094 13.6222 17.6721 12.459C17.7195 12.4259 17.7665 12.3924 17.8131 12.3585C17.8259 12.3485 17.839 12.339 17.8522 12.3299C19.4263 11.1755 20.6251 9.57996 21.2954 7.7431C21.4374 7.35399 21.8679 7.15366 22.2571 7.29565C22.6462 7.43764 22.8465 7.86819 22.7045 8.2573C22.0214 10.1293 20.8616 11.7836 19.3475 13.0608L20.5737 14.5172C20.8405 14.834 20.7999 15.3071 20.483 15.5739C20.1661 15.8407 19.693 15.8001 19.4262 15.4833L18.1371 13.9522C17.213 14.543 16.2124 14.9946 15.1677 15.2969L15.7321 17.8376C15.8219 18.2419 15.567 18.6425 15.1626 18.7324C14.7583 18.8222 14.3576 18.5672 14.2678 18.1629L13.7025 15.6182C13.1414 15.703 12.5724 15.7461 12 15.7461C11.4275 15.7461 10.8585 15.703 10.2974 15.6182L9.73211 18.1629C9.64228 18.5672 9.24167 18.8222 8.83731 18.7324C8.43295 18.6425 8.17798 18.2419 8.26781 17.8376L8.83222 15.2969C7.78752 14.9946 6.78696 14.543 5.86277 13.9522L4.57369 15.4833C4.30691 15.8001 3.83377 15.8407 3.51691 15.5739C3.20005 15.3071 3.15945 14.834 3.42623 14.5172L4.65239 13.0608C3.13831 11.7836 1.97851 10.1293 1.2954 8.2573C1.15341 7.86819 1.35374 7.43764 1.74286 7.29565Z"
        fill="currentColor"
      />
    </svg>
  )
}
